export default __webpack_public_path__ + "static/media/11.9.1b8cda8f.jpg";